import fetch,{ postFrom } from '../utils/fetch';
/**
 * 登录 退出接口
 */

// 登录
export function login(data) {
    return postFrom('/login', data);
}

// 退出
export function logout() {
    return fetch({
        method: 'POST',
        url: '/logout',
    })
}

// userinfo
export function getUser() {
    return fetch({
        method: 'GET',
        url: '/userInfo',
    })
}

export function menuAuthResource() {
  return fetch({
    method: 'GET',
    url:'/menuAuthResource',
  })
}

export function changePassword(params) {
  return fetch({
    method: 'POST',
    url: '/user/password/change',
    params: params
  })
}
  export function loginPerCheck(params) {
    return fetch({
      method: 'POST',
      url: '/login/preCheck',
      params: params
    })
  }

export function sendVerification(params) {
  return fetch({
    method: 'POST',
    url: '/login/sendVerification',
    params: params
  })
}

export function checkVerification(params) {
  return fetch({
    method: 'POST',
    url: '/login/checkVerification',
    params: params
  })
}


